let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("f8ZVM"), load("17Qwb"), load("dWaws"), load("PNMmE")]).then(() => parcelRequire('cxX4J'));